import React, { ChangeEvent, FC } from "react";
import { MediaFile } from "@models/Common";
import styles from "./FileSelector.module.css";

interface FileSelectorProps {
    label?: string;
    id: string;
    maxSize?: number; // Max file size in MB
    errorMessage?: string;
    onFileChange: (file: MediaFile | null, error: string) => void;
    acceptedFileTypes?: string; // Optional prop to specify accepted file types
}

const FileSelector: FC<FileSelectorProps> = ({
    label,
    id,
    maxSize = 25, // Default max file size to 25MB
    errorMessage,
    onFileChange,
    acceptedFileTypes = "*", // Default to allow all file types
}) => {
    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0]; // Renamed variable to selectedFile
        if (selectedFile) {
            if (selectedFile.size > maxSize * 1024 * 1024) {
                onFileChange(null, `File size should be less than ${maxSize}MB`);
            } else {
                const reader = new FileReader();
                reader.onloadend = () => {
                    onFileChange(reader.result, "");
                };
                reader.readAsDataURL(selectedFile);
            }
        }
    };

    return (
        <div className={styles.container}>
            {label && <label htmlFor={id} className={styles.label}>{label}</label>}
            <input
                type="file"
                accept={acceptedFileTypes}
                onChange={handleFileChange}
                id={id}
                className={`${styles.input} ${errorMessage ? styles.invalid : ""}`} // Apply invalid class if there's an error
            />
            {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
        </div>
    );
};

export default FileSelector;
